(function () {
    "use strict";
    angular
        .module("skillBuilderSaaS")
        .directive("bamboraPaymentFormConfirmation", function () {
        return {
            restrict: "E",
            scope: {},
            bindToController: true,
            template: "<div sb-loading class='well'></div>",
            controller: ["checkoutResource", "checkoutService", "messageService", "$state", BamboraPaymentFormConfirmationCtrl],
            controllerAs: "vm"
        };
        function BamboraPaymentFormConfirmationCtrl(checkoutResource, checkoutService, messageService, $state) {
            var search = location.search.substring(1);
            var responseDetails = search ? JSON.parse('{"' + search.replace(/&/g, '","').replace(/=/g, '":"') + '"}', function (key, value) { return key === "" ? value : decodeURIComponent(value); }) : {};
            if (responseDetails.trnApproved === "1") {
                //all is good
                checkoutService.wizard.isStep4Valid = true;
                $state.go("main.checkout.step5", { orderId: checkoutService.model.details.orderGuid }, { location: "replace" });
            }
            else {
                //Transaction is either declined or canceled by user
                checkoutService.model.error = true;
                //messageService.error("storefront.checkout.error.paymentFailed.moneris");
                $state.go("main.checkout.step3", {}, { location: "replace" });
            }
        }
    });
}());
